import api from './axios';

const BASE = '/categories';

export const getCategories = (page = 0, size = 10, filters = {}) =>
  api.get(BASE, { params: { page, size, ...filters } });

export const getCategory = (id) => api.get(`${BASE}/${id}`);

export const createCategory = (data) => api.post(BASE, data);

export const updateCategory = (id, data) => api.put(`${BASE}/${id}`, data);

export const deleteCategory = (id) => api.delete(`${BASE}/${id}`);
